//@flow
import React from "react"
import { Route, Redirect } from "react-router-dom"
import { isLoggedIn, isAdmin } from "../Auth"

/**
 * Generates a route that redirects users to login if not
 * authenticated.
 * @return {Route} A route that sends the user to a protected component.
 */
const PrivateRoute = ({
  component: Component,
  adminRequired,
  ...rest
}: {
  adminRequired: boolean,
  component: Class<React$Component<*, *>>
}) => (
  <Route
    {...rest}
    render={props =>
      isLoggedIn() ? (
        !adminRequired || isAdmin() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/auth/pending",
              state: {
                from: props.location
              }
            }}
          />
        )
      ) : (
        <Redirect
          to={{
            pathname: adminRequired ? "/auth/login" : `/go/refresh`,
            state: {
              from: props.location
            }
          }}
        />
      )}
  />
)

export default PrivateRoute



// WEBPACK FOOTER //
// ./src/RoutingHelpers/PrivateRoute.js